// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"628":"fbace799","663":"fbace799","730":"de005d12"}[chunkId] + ".chunk.css";
};